<template>
    <div style="height: 100%">
        <vs-chip style="height: 60%; top:20%" :color="statusColor(params.value, params.data.id)">{{params.value}}</vs-chip>
    </div>
</template>
<script>
    import Vue from "vue";

    export default Vue.extend({
        methods:{
            statusColor(status, id) {
                switch (status){
                    case this.$t("MeetingPlanned"):
                        return '#9b59b6';
                    case this.$t("MeetingInProgress"):
                        return '#e67e22';
                    case this.$t("MeetingStopped"):
                        return '#e74c3c';
                    case this.$t("SentForConfirmation"):
                        return '#3498db';
                    case this.$t("MeetingFinished"):
                        return '#2ecc71';
                    default:
                        return 'dark';
                }
            }
        }
    });

</script>
